<template lang="pug">
div
  ValidationProvider(
    v-slot="{ errors }"
    rules="required"
    name="name"
  )
    #name.form-group.mb-10(:class="{ 'has-error': errors[0] }")
      label.control-label(for="name")
        | Name
        abbr(title="required") *
      AppInput(
        v-model="name"
        placeholder="Name"
      )
      span.help-block {{ errors[0] }}
  ValidationProvider(
    v-slot="{ errors }"
    name="address"
  )
    #address.form-group.mb-10(:class="{ 'has-error': errors[0] }")
      label.control-label(for="address")
        | Address
      textarea.form-control.required(
        v-model="address"
        rows="3"
      )
      span.help-block {{ errors[0] }}
</template>

<script>
import { mapState } from 'vuex';
import { mapFormFields } from '~/utils/form_utils';

export default {
  name: 'ClientDialogTabGeneral',
  computed: {
    ...mapState(['isNewForm', 'organization']),
    ...mapFormFields('client', {
      name: 'name',
      address: 'address',
    }),
  },
};
</script>
